import React from 'react';

function ComBal () {
    return (
        <div className="espacio container-md align-items-center">
            <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingOne">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        Comunicados
                    </button>
                    </h2>
                    <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1610602933/ARBAL/SIAR/covid19.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                        Semana BAL
                    </button>
                    </h2>
                    <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1613584897/ARBAL/SIAR/screen-0.jpg" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                        Juegos Deportivos y Culturales BAL
                    </button>
                    </h2>
                    <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1613584735/ARBAL/SIAR/12-1.jpg" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="flush-headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                        Baleños por la educación
                    </button>
                    </h2>
                    <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1613584735/ARBAL/SIAR/beca-nuestro-itam_1.png" alt="..."></img>
                    <div class="accordion-body"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComBal